import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { makeSxStyles } from "ui";

// The full-viewport centering + background glow shared by the logged-out
// auth pages - see auth-router.tsx, which wraps its whole <Routes> tree in
// these same styles. A page reached AFTER login that still needs the same
// "auth card" look (the reply-email setup step, ESR-1614) can't reuse that
// wrapper directly since it's rendered by DashboardRouter, not AuthRouter -
// hence this standalone copy.
const FullScreenAuthLayout: FC<PropsWithChildren> = ({ children }) => {
  const styles = useStyles();
  return <Box sx={styles.container}>{children}</Box>;
};

const useStyles = makeSxStyles(() => ({
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background:
      "radial-gradient( ellipse farthest-corner at top right, rgba(0, 128, 184, 0.30) 10%, rgba(138, 206, 255, 0) 80%)",
    filter: "grayscale(30%)",
  },
}));

export default FullScreenAuthLayout;
